import React from 'react';

const LoginSignupContext = React.createContext({});

export default LoginSignupContext;
